import React, { useState } from 'react';
import NewColumnForm from './NewColumnForm';
import { Button } from 'shards-react';

const AddNewColumn = () => {
	const [showList, setShowList] = useState(false);
	const toggleList = () => setShowList((oldState) => !oldState);

	return (
		<div className='add-new-type mr-2'>
			{showList ? (
				<NewColumnForm classes='card p-2 border' closeModal={toggleList} />
			) : (
				<Button theme='success' onClick={toggleList}>
					<i className='fas fa-folder-plus align-middle mr-2' style={{ fontSize: '22px' }} />
					<span className='align-middle'>Neuer Typ</span>
				</Button>
			)}
		</div>
	);
};

export default AddNewColumn;
